import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { ReactComponent as PersonSizesImg } from '@/assets/images/person-sizes.svg'
import item1 from '@/assets/images/start-pack/item1.webp'
import item2 from '@/assets/images/start-pack/item2.webp'
import item3 from '@/assets/images/start-pack/item3.webp'
import item4 from '@/assets/images/start-pack/item4.webp'
import item5 from '@/assets/images/start-pack/item5.webp'
import item6 from '@/assets/images/start-pack/item6.webp'
import item7 from '@/assets/images/start-pack/item7.webp'

import DocumentsListModal from '@/components/Modals/DocumentsListModal/DocumentsListModal'
import Modal from '@/components/Modals/Modal/Modal'

import { getStoreCityFromFormats } from '@/store/slices/app'

import styles from './StartPack.module.scss'

const startPacs = [
  {
    id: 0,
    label: 'Футболка участника',
    img: {
      src: item1,
      width: 'auto',
      height: 327,
    },
  },
  {
    id: 1,
    label: 'Медаль на финише',
    img: {
      src: item2,
      width: 265,
      height: 323,
    },
  },
  {
    id: 2,
    label: 'Номер участника с чипом хронометража',
    img: {
      src: item3,
      width: 238,
      height: 179,
    },
  },
  {
    id: 3,
    label: 'Наклейка для камеры хранения',
    img: {
      src: item4,
      width: 238,
      height: 170,
    },
  },
  {
    id: 4,
    label: 'Брендированный мешок',
    img: {
      src: item5,
      width: 302,
      height: 323,
    },
  },
  {
    id: 5,
    label: 'Электронный сертификат участника',
    img: {
      src: item6,
      width: 238,
      height: 179,
    },
  },
  {
    id: 6,
    label: 'Подарки от партнёров*',
    img: {
      src: item7,
      width: 346,
      height: 261,
    },
  },
]

function StartPack() {
  const selectedCity = useSelector(getStoreCityFromFormats)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isOpenDocumentsModal, setIsOpenDocumentsModal] = useState(false)
  const [activeItem, setActiveItem] = useState(0)

  return (
    <section className={styles.startPack} id="startPack">
      <div className={styles.inner}>
        <h2 className={styles.title}>Стартовый пакет</h2>
        <p className={styles.desc}>Каждый участник гарантированно получает приятные подарки!</p>

        <div className={styles.itemsPreviewWrap}>
          <div className={styles.itemsCard}>
            <ul className={styles.items}>
              {startPacs.map((item) => (
                <li
                  className={`${styles.item} ${item.id === activeItem ? styles.itemActive : ''}`}
                  onClick={() => setActiveItem(item.id)}
                  key={item.id}
                >
                  {item.label}
                </li>
              ))}
            </ul>

            <p className={styles.footnote}>*подарки от партнёров могут меняться в зависимости от выбранного города</p>
          </div>

          <div className={styles.previewCard}>
            {startPacs.map(
              (item) =>
                item.id === activeItem && (
                  <img
                    className={`${styles.itemImg} lazyload`}
                    src={item.img.src}
                    width={item.img.width}
                    height={item.img.height}
                    alt={item.img.label}
                    key={item.id}
                  />
                )
            )}

            {activeItem === 0 && (
              <button
                className={`${styles.button} ${styles.buttonSizes}`}
                onClick={() => setIsOpenModal(true)}
                type="button"
              >
                таблица размеров
              </button>
            )}
          </div>

          <Modal isOpen={isOpenModal} onClose={() => setIsOpenModal(false)}>
            <div className={styles.modalInner}>
              <PersonSizesImg className={styles.personSizes} />

              <div className={styles.tables}>
                <table className={styles.table}>
                  <tbody>
                    <tr>
                      <th className={styles.th} />
                      <th className={styles.th}>
                        <span className={styles.thValue}>A</span> Длина от края воротника до низа, см
                      </th>
                      <th className={styles.th}>
                        <span className={styles.thValue}>B</span> Ширина на уровне груди, см
                      </th>
                      <th className={styles.th}>
                        <span className={styles.thValue}>C</span> Ширина по низу, см
                      </th>
                      <th className={styles.th}>
                        <span className={styles.thValue}>D</span> Длина рукава, см
                      </th>
                    </tr>
                    <tr className={styles.tr}>
                      <td className={styles.td}>XXS</td>
                      <td className={styles.td}>66</td>
                      <td className={styles.td}>44</td>
                      <td className={styles.td}>44</td>
                      <td className={styles.td}>19</td>
                    </tr>
                    <tr className={styles.tr}>
                      <td className={styles.td}>XS</td>
                      <td className={styles.td}>66</td>
                      <td className={styles.td}>45</td>
                      <td className={styles.td}>45</td>
                      <td className={styles.td}>19,5</td>
                    </tr>
                    <tr className={styles.tr}>
                      <td className={styles.td}>S</td>
                      <td className={styles.td}>68</td>
                      <td className={styles.td}>46</td>
                      <td className={styles.td}>46</td>
                      <td className={styles.td}>20</td>
                    </tr>
                    <tr className={styles.tr}>
                      <td className={styles.td}>M</td>
                      <td className={styles.td}>71</td>
                      <td className={styles.td}>48</td>
                      <td className={styles.td}>48</td>
                      <td className={styles.td}>21,5</td>
                    </tr>
                    <tr className={styles.tr}>
                      <td className={styles.td}>L</td>
                      <td className={styles.td}>74</td>
                      <td className={styles.td}>54</td>
                      <td className={styles.td}>54</td>
                      <td className={styles.td}>24</td>
                    </tr>
                    <tr className={styles.tr}>
                      <td className={styles.td}>XL</td>
                      <td className={styles.td}>75</td>
                      <td className={styles.td}>60</td>
                      <td className={styles.td}>60</td>
                      <td className={styles.td}>25</td>
                    </tr>
                    <tr className={styles.tr}>
                      <td className={styles.td}>2 XL</td>
                      <td className={styles.td}>79</td>
                      <td className={styles.td}>65</td>
                      <td className={styles.td}>65</td>
                      <td className={styles.td}>27</td>
                    </tr>
                  </tbody>
                </table>

                <p className={styles.tableLabel}>Дети</p>
                <table className={styles.table}>
                  <tbody>
                    <tr className={styles.tr}>
                      <td className={styles.td}>140</td>
                      <td className={styles.td}>46</td>
                      <td className={styles.td}>39</td>
                      <td className={styles.td}>39</td>
                      <td className={styles.td}>16</td>
                    </tr>
                    <tr className={styles.tr}>
                      <td className={styles.td}>152</td>
                      <td className={styles.td}>52</td>
                      <td className={styles.td}>40</td>
                      <td className={styles.td}>40</td>
                      <td className={styles.td}>17</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Modal>
        </div>

        <h2 className={`${styles.title} ${styles.titleHowToGet}`}>как получить стартовый пакет</h2>
        <div className={styles.howToGet}>
          <div className={styles.documentsCard}>
            <p className={styles.documentsLabel}>Для получения стартового пакета при себе необходимо иметь:</p>

            <ul className={styles.documents}>
              <li className={styles.document}>Паспорт или другой документ, удостоверяющий личность;</li>
              <li className={styles.document}>
                Оригинал медицинской справки об отсутствии противопоказаний для забега на выбранную дистанцию;
              </li>
              <li className={styles.document}>Для участников младше 18 лет оригинал разрешения от родителей.</li>
            </ul>
          </div>

          <div className={styles.linksCard}>
            <p className={styles.linksText}>
              Если ты не можешь получить стартовый пакет в указанные дни, за тебя это могут сделать друзья или знакомые
              при предъявлении следующих документов:
            </p>

            <button
              className={`${styles.link} ${styles.linkDocs}`}
              onClick={() => setIsOpenDocumentsModal(true)}
              type="button"
            >
              список документов
            </button>
            <a className={`${styles.link} ${styles.linkPermissions}`} href="https://забег.рф/soglasie.pdf">
              разрешение от родителей
            </a>
            <a className={`${styles.link} ${styles.linkMed}`} href="#medical">
              медицинская справка
            </a>
            <a
              className={`${styles.link} ${styles.linkDocs}`}
              href="https://drive.google.com/file/d/1qJwTQ893bHDLxKRkYhhpfRqLIVJBxyWr/view?usp=drive_link"
            >
              Согласие на обработку персональных данных
            </a>
          </div>
        </div>

        <div className={styles.getInfo}>
          <p className={styles.getInfoItem}>
            {selectedCity?.info?.registration_schedule?.length > 0
              ? selectedCity.info.registration_schedule.map((item, index) => (
                  <React.Fragment key={index}>
                    {String(item).trim()} <br />
                  </React.Fragment>
                ))
              : 'дата выдачи*'}
          </p>
          <p className={styles.getInfoItem}>{selectedCity?.city?.name_ru || 'город*'}</p>
          <p className={styles.getInfoItem}>{selectedCity?.info?.registration_address || 'адрес*'}</p>
        </div>

        <p className={styles.getInfoFootnote}>
          {(!selectedCity?.info?.registration_schedule ||
            !selectedCity?.city?.name_ru ||
            !selectedCity?.info?.registration_address) &&
            '*информация в разработке'}
        </p>
      </div>
      <DocumentsListModal isOpen={isOpenDocumentsModal} onClose={() => setIsOpenDocumentsModal(false)} />
    </section>
  )
}

export default StartPack
